<div class="container-fuild">
  <div class="row pt-4 d-flex align-items-center" *ngIf="isSimplifyH1b ? false : true">
    <div class="col-md-9 step-title p-0">
      <!-- <h5 class="mb-0">Get Receipts</h5>
            <p class="mb-0" style="font-size:14px">Get Receipts Details of Petition</p> -->
      <div class="page-header">
        <h2>Get Receipts</h2>
        <p>Get Receipt Details of Petition</p>
      </div>
    </div> 
    <div class="col-md-2 editBtn" *ngIf="!isWizardFlag">
      <lib-step-status-update-component-library
        [visaType]="inputData.caseType != 'I130' ? inputData.visatype : inputData.caseType" [stepDetails]="stepDetails"
        type="EDIT">
      </lib-step-status-update-component-library>
    </div>
    <div class="col-md-1 pr-0 pl-2 d-flex justify-content-end" *ngIf="!isWizardFlag">
      <lib-maximize-dialog-library [configData]="{'layoutCode':inputData?.layoutCode}"></lib-maximize-dialog-library>
      <i (click)="handleClose();" class="close-icon pi pi-times"></i>
    </div>
  </div>
  <div class="row pt-1 pl-3 d-flex align-items-center" *ngIf="isSimplifyH1b ? true : false">
    <div class="col-md-9 step-title p-0">
      <!-- <h5 class="mb-0">Get Receipts</h5>
            <p class="mb-0" style="font-size:14px">Get Receipts Details of Petition</p> -->
      <div class="page-header pl-0 headerPortion" *ngIf="!isWizardFlag">
        <h2>Get Receipts</h2>
        <p class="m-0">Get Receipt Details of Petition</p>
      </div>
    </div>
    <div class="col-md-3 editBtn headerSubPortion px-0" *ngIf="!isWizardFlag"> 
      <ul>
        <li class="col-auto px-0 firstPortion"> 
          <lib-step-status-update-component-library
          [visaType]="inputData.caseType != 'I130' ? inputData.visatype : inputData.caseType" [stepDetails]="stepDetails"
          type="EDIT">
        </lib-step-status-update-component-library>
        </li>
        <li class="col-auto pr-0 pl-2 secondPortion">
          <lib-maximize-dialog-library [configData]="{'layoutCode':inputData?.layoutCode}"></lib-maximize-dialog-library>
          <i (click)="handleClose();" class="close-icon pi pi-times"></i>
        </li>
      </ul>  
    </div>  

    <!-- <div class="col-md-2 editBtn">
      <lib-step-status-update-component-library
        [visaType]="inputData.caseType != 'I130' ? inputData.visatype : inputData.caseType" [stepDetails]="stepDetails"
        type="EDIT">
      </lib-step-status-update-component-library>
    </div>
    <div class="col-md-1 pr-0 d-flex justify-content-end">
      <lib-maximize-dialog-library [configData]="{'layoutCode':inputData?.layoutCode}"></lib-maximize-dialog-library>
      <i (click)="handleClose();" class="close-icon pi pi-times"></i>
    </div> -->
  </div>
  <div class="row" *ngIf="!isWizardFlag">
    <div class="col-md-12 p-0">
      <!-- <lib-assigning-task-library [visaType]="inputData.visatype" [stepDetails]="stepDetails"
        (updateStatus)="updateStepStatus($event)">
      </lib-assigning-task-library> -->
      <lib-assigning-task-library [visaType]="inputData.visatype" [stepDetails]="stepDetails"
        (updateStatus)="updateStepStatus($event)" [isViewMode]="this.inputData['isViewMode']" [isCaseRequest]="this.inputData['isCaseRequest']">
      </lib-assigning-task-library>
    </div>
  </div>
  <p-divider class="header-divider" *ngIf="isSimplifyH1b || isWizardFlag ? false : true"></p-divider>
  <form (ngSubmit)="postGetReceipts()" #getReceiptsForm="ngForm" class="pb-3 pt-0 w-100">
    <div class="main-body footer-adjust" [ngClass]="isWizardFlag ? 'noScroll' : ''">
      <lib-last-update-library *ngIf="!isWizardFlag" [inputDetails]="stepDetails" [primaryData]="inputData" [sectionCode]="sectionCode">
      </lib-last-update-library>


      <!-- OCR I797 for H1-B -->
      <div class="receipt-upload mt-4" *ngIf="inputData.visatype == 'H1-B'">      
        <div class="row file-upload-container">      
          <div class="col-md-5">
            <h6 class="upload-head">Upload Receipt Note - I-797</h6>
            <p>
              <span class="sub-head">Required Documents: </span><span class="sub-text">Receipt Note</span>
            </p>
            <!-- <p>
              <span class="sub-head">Upload: </span><span class="sub-text">PDF, JPG, JPEG</span>
            </p> -->
            <file-upload-library style="width: 100%;" (filesDataChange)="onFilesDataChange($event)"
              [isShowUploadedList]="false" [fileUploadConfigurations]="fileUploadConfigurations">
            </file-upload-library>
          </div>      
          <div class="col-md-3">
            <p><img class="preview-img" alt="Preview" src="../../../../assets/images/details_default.png" /></p>
            <button type="button" [disabled]="!ocrReceiptUploadedFilesData" class="btn btn-primary mr-3"
              (click)="convertUpload()">Convert</button>
            <i class="info-icon fa fa-info-circle" pTooltip="Extract Details"></i>
          </div>      
        </div>
      </div>
      
      <div class="row mb-3">
        <div [ngClass]="isWizardFlag ? 'col-md-3 form-group input-disabled pl-0' : 'col-md-3 form-group input-disabled'">
          <label class="label-cls required"> Receipt Number</label>
          <input type="text" class="im-input mw-100" name="receiptNumber" #receiptNumber="ngModel"
            [readOnly]="disabledControls" placeholder="Enter" [(ngModel)]="receiptDetails.receiptNumber" [pattern]="receiptNumberRegexp" (ngModelChange)="receiptNumChanged(receiptDetails.receiptNumber)" pInputText
            required />
            <small>Ex : ABC0123456789</small>
          <div
            *ngIf="getReceiptsForm.controls['receiptNumber']?.touched && getReceiptsForm.controls['receiptNumber']?.invalid">
            <span class="invalid-message" *ngIf="getReceiptsForm.controls['receiptNumber']?.errors?.required">
              {{getGlobalErrorMessages('REQUIRED')}}
            </span>
            <span  class="invalid-message" *ngIf="getReceiptsForm.controls['receiptNumber']?.errors?.pattern">{{ getGlobalErrorMessages("INVALID_FORMAT") }}</span>
          </div>
        </div>
        <div [ngClass]="isWizardFlag ? 'col-md-3 calendar-input pl-0' : 'col-md-3 calendar-input'">
          <label class="label-cls required"> Receipt Date </label>
          <p-calendar type="text" name="receiptDate" class="mw-100" id="receiptDate" appendTo="body"
            [(ngModel)]="receiptDetails.receiptDate" [disabled]="disabledControls" inputId="icon" [showIcon]="true"
            dateFormat="mm/dd/yy" [maxDate]="receiptMaxDate" yearRange="1910:2050" [monthNavigator]="true"
            [yearNavigator]="true" placeholder="MM/DD/YYYY" required> </p-calendar>
          <div
            *ngIf="getReceiptsForm.controls['receiptDate']?.touched && getReceiptsForm.controls['receiptDate']?.invalid">
            <span class="invalid-message" *ngIf="getReceiptsForm.controls['receiptDate']?.errors?.required">
              {{getGlobalErrorMessages('REQUIRED')}}
            </span>
          </div>
        </div>
      </div>
      <div [ngClass]="isWizardFlag ? 'row mb-2 customPortion' : 'row mb-2'">
        <div class="col-md-12 p-0">
          <file-upload-library style="width: 100%;" [fileUploadConfigurations]="fileUploadConfigurations">
          </file-upload-library>
        </div>
      </div>
    </div>
    <p-divider *ngIf="!isWizardFlag"></p-divider>
    <div class="row">
      <div class="col-md-6 pl-0">
        <div class="d-flex justify-content-start">
          <button pButton type="submit" label="Save" class="btn btn-primary"
            [ngClass]="getReceiptsForm.invalid  || disabledControls ? 'mr-3 btn-success_disabled btn btn-primary':'btn btn-primary mr-3'"
            [disabled]="getReceiptsForm.invalid  || disabledControls"></button>

          <button pButton type="button" label="Cancel" class="btn btn-primary" [disabled]="disabledControls"
            (click)="handleCancel()">
          </button>
        </div>

      </div>

      <div class="col-md-6 completeStep" *ngIf="!isWizardFlag">
        <lib-step-status-update-component-library
          [visaType]="inputData.caseType != 'I130' ? inputData.visatype : inputData.caseType"
          [stepDetails]="stepDetails" [type]="typeOfButton" (resetForm)="getReceipts()" [showPreviousStepBtn]="true" class="d-flex col-12 justify-content-end">
        </lib-step-status-update-component-library>
      </div>
    </div>
  </form>
</div>
